import React from 'react';
import validate from 'validate.js';
import { filter } from 'lodash';
import validateSurveillanceForm from '../../app-surveillance-info/forms/validateSurveillanceForm';
import { FormattedMessage } from 'react-intl';

const validateParkingForm = ({
  is_available = false,
  types = {},
  description = '',
  has_surveillance = false,
  surveillance_description
}) => {
  const optionMessage = <FormattedMessage id="hosting.validate_parking_form.select_option" defaultMessage="Please select an option" />;
  const parkingOption = <FormattedMessage id="hosting.validate_parking_form.select_parking" defaultMessage="Please select a parking option" />;
  const parkingDescription = <FormattedMessage id="hosting.validate_parking_form.describe_parking_options" defaultMessage="Please enter a description of the parking options" />;

  validate.validators.parkingTypes = (value) => {
    return filter(value, (type) => type).length ? undefined : optionMessage;
  };

  return {
    is_available: validate.single(is_available,
      {
        presence: {
          allowEmpty: false,
          message: parkingOption
        }
      }),
    types:
      {
        _error: validate.single(types, {
          presence: {
            allowEmpty: false,
            message: optionMessage
          },
          parkingTypes: true
        })
      },
    description: validate.single(description,
      {
        presence: {
          allowEmpty: !is_available,
          message: parkingDescription
        },
        length: {
          minimum: 35,
          tooShort: <FormattedMessage id="hosting.validate_parking_form.minimum_characters" defaultMessage="Minimum 35 characters" />,
          maximum: 1000,
          tooLong: <FormattedMessage id="hosting.validate_parking_form.maximum_characters" defaultMessage="Maximum 1000 characters" />
        }
      }),
    ...validateSurveillanceForm({ has_surveillance, surveillance_description })
  };
};

export default validateParkingForm;
